import React, { Component } from 'react';
import PropTypes from 'prop-types';
import StripeCheckout from 'react-stripe-checkout';
import FormStepButton from '../forms/FormStepButton';
import { calculateCharges } from '../../utils';
import API_KEYS from '../../constants/apiKeys';


const propTypes = {
    email: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    formValues: PropTypes.object.isRequired,
    onToken: PropTypes.func.isRequired,
    buttonProps: PropTypes.object,
};

class PaymentCheckout extends Component {
    render() {
        const {
            email,
            name,
            buttonProps,
            onToken,
            formValues,
        } = this.props;
        const charges = calculateCharges(formValues);

        return (
            <StripeCheckout
                name={name}
                token={onToken}
                stripeKey={API_KEYS.STRIPE_PUBLISHABLE_KEY}
                allowRememberMe={false}
                email={email}
                amount={charges.stripe_total_charge}
                currency="GBP"
            >
                <FormStepButton {...buttonProps}>
                    Pay & Confirm Booking
                </FormStepButton>
            </StripeCheckout>
        );
    }
}

PaymentCheckout.propTypes = propTypes;

export default PaymentCheckout;
